export default __webpack_public_path__ + "static/media/biblioteca.5587d165.jpg";